import { render, staticRenderFns } from "./VisitedProfiles.vue?vue&type=template&id=8c7b902e&"
import script from "./VisitedProfiles.vue?vue&type=script&lang=js&"
export * from "./VisitedProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports